export default __webpack_public_path__ + "static/media/EW2A1883.9120a386.jpg";